export const LEGAL_ENTITY = "Stratify Analytics Inc.";
export const PRODUCT_NAME = "Stratify";

export const LEGAL_RELATED_LINKS = [
  { to: "/terms-of-use", label: "Terms of Use" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/refund-policy", label: "Refund Policy" },
  { to: "/subscription-terms", label: "Subscription Terms" },
  { to: "/support", label: "Support" },
];

/** @param {string} currentPath */
export function relatedLegalLinks(currentPath) {
  return LEGAL_RELATED_LINKS.filter((item) => item.to !== currentPath);
}

export const LEGAL_SHARED = {
  entity: LEGAL_ENTITY,
  product: PRODUCT_NAME,
  simulation:
    "Stratify is a research, historical backtesting, and simulated Cloud Paper Bot product. Backtests, paper results, and alerts do not guarantee future performance.",
  noLiveTrading:
    "Automated live trading is not included in these subscriptions. Stratify does not place live brokerage orders.",
  sellers:
    "Apple is the seller of record for App Store purchases. Stratify Analytics Inc. is the seller of record for website purchases processed by Stripe.",
  marketing:
    "Marketing messages are optional. Accepting a subscription is not consent to marketing, and marketing consent is not required to subscribe.",
  founderDraft:
    "Founder draft — not independently counsel-reviewed. Publication date: Pending founder approval.",
  billingDraftNote:
    "The website billing language below is a founder draft pending approval. It does not change the May 26, 2026 App Store policy date on this page.",
};
